import { Button, useDisclosure } from '@chakra-ui/react';

import RestrictAccessModal from '../RestrictAccessModal';

import { RestrictAccessButtonProps } from './types';

function RestrictAccessButton({ employeeId, employeeName, onRestrict }: RestrictAccessButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        height="40px"
        onClick={(e) => {
          e.stopPropagation();
          onOpen();
        }}
      >
        Restrict Access
      </Button>
      <RestrictAccessModal
        employeeId={employeeId}
        employeeName={employeeName}
        isOpen={isOpen}
        onClose={onClose}
        onRestrict={onRestrict}
      />
    </>
  );
}

export default RestrictAccessButton;
